import theme from '@/config/theme';
import styled from 'vue-styled-components';

const ContainerProps = { width: String };

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Header = styled.header`
  width: 100%;

  .title {
    color: #40433e;
    font-size: 1.4rem;
  }
`;

export const Main = styled.main`
  display: flex;
  gap: 1.5rem;
`;

export const Container = styled('div', ContainerProps)`
  width: ${(props) => props.width ?? '100%'};
  background-color: ${theme.colors.white};
  border-radius: 0.5rem;
  padding: 0.5rem 0;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);

  div.header {
    width: 100%;

    .title {
      font-size: 1.2rem;
      font-weight: bold;
      color: #40433e;
      padding: 1rem;
    }

    ::after {
      display: inline-block;
      content: "";
      border-top: 1px solid #f1f2f0;
      width: 100%;
      transform: translateY(-1rem);
    }
  }
  .link{
    position: relative;
    top: 30px;
    margin-left: 5px;
  }
  div.contents {
    padding: 0 1.5rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .title {
      font-size: 0.9rem;
      color: #40433e;
      font-weight: bold;
    }

    ul.filters {
      list-style: none;
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 1rem;

      li {
        padding-top: 9px;
        display: flex;
        align-items: center;
        gap: 0.5rem;

        &.legendBlue::before {
          content: "";
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 0.47rem;
          background-color: #193280;
        }

        &.legendOrange::before {
          content: "";
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 0.47rem;
          background-color: #e7b145;
        }
      }
    }
  }
`;

export const CalendarContainer = styled.div`
  width: 75%;

  & .custom-calendar.vc-container {
    --day-border: 1px solid #b8c2cc;
    --day-border-highlight: 1px solid #b8c2cc;
    --day-width: 90px;
    --day-height: 90px;
    --weekday-bg: #f8fafc;
    --weekday-border: 1px solid #eaeaea;
    font-family: inherit;

    border-radius: 0;
    width: 100%;

    & .vc-day-layer .vc-highlight {
      width: 100%;
      height: 100%;
      border-radius: 0 !important;
      opacity: 0.5;
    }

    & .itemContainer {
      display: flex;
      flex-direction: column;
      z-index: 10;
      height: 100%;
      overflow: hidden;

      & .dayItem {
        color: ${theme.colors.black};
        font-size: 1rem;
      }

      & .contentItem {
        flex-grow: 1;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 0;
        }

        & .text {
          font-size: 0.75rem;
          padding: 0.25rem;
          margin-top: 0;
          margin-bottom: 0.25rem;
          line-height: 1.25;
          border-radius: 0.25rem;

          &.blue {
            background-color: blue;
            color: white;
          }

          &.orange {
            background-color: orange;
          }
          &.black {
            background-color: black;
            color: white;
          }
          &.red {
            background-color: red;
            color: white;
          }

          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    & .vc-header {
      background-color: #f1f5f8;
      padding: 10px 0;
    }
    & .vc-weeks {
      padding: 0;
    }
    & .vc-weekday {
      background-color: var(--weekday-bg);
      border-bottom: var(--weekday-border);
      border-top: var(--weekday-border);
      padding: 5px 0;
    }
    & .vc-day {
      padding: 0 5px 3px 5px;
      text-align: left;
      height: var(--day-height);
      min-width: var(--day-width);
      background-color: white;

      /* .active &.weekday-1,
      &.weekday-7 {
        background-color: #eff8ff;
      } */

      &:not(.on-bottom) {
        border-bottom: var(--day-border);
        &.weekday-1 {
          border-bottom: var(--day-border-highlight);
        }
      }
      &:not(.on-right) {
        border-right: var(--day-border);
      }
    }
    & .vc-day-dots {
      margin-bottom: 5px;
    }
  }
`;
